<template>
  <div class="c-nav-dropdown__links nav-with-icon">
    <sc-image v-if="fields && fields.icon" :media="fields.icon" class="c-nav-dropdown__icon" />
    <sc-text
      v-if="fields && fields.heading"
      :field="fields.heading"
      class="c-nav-dropdown__headline"
    />
    <div class="c-link-list">
      <sc-placeholder name="jss-link" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Text, Image, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-DropDown-FullWidthLinkSection',
  components: {
    ScText: Text,
    ScImage: Image,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  }
};
</script>
